import React from "react";
import { ReactComponent as CarousleUndeline } from "../../assests/carousleUndeline.svg";

function OrganizerInCarosel({
  heading,
  organizer,
  hexCode,
  setOrganizerDetails,
  setOrganizerPopup,
  scrollRef,
}) {
  const handleClickSponsor = (obj) => {
    setOrganizerDetails(obj);
    setOrganizerPopup(true);
  };
  var coverStyle = {
    background: `linear-gradient(81.11deg, rgba(86, 86, 86, 0.4) 25.51%, rgba(21, 21, 21, 0.4) 74.24%) `,
  };
  var linkStyle = { color: hexCode };
  return (
    <div
      className=" h-[194px] w-[320px] shrink-0 flex-grow p-[20px]"
      style={coverStyle}
      ref={scrollRef}
    >
      <p className="text-small">{heading}</p>
      <div className="no-scrollbar overflow-y-scroll w-[100%] h-[100%] pt-[10px] ">
        {organizer?.map((obj, i) => {
          return (
            <div
              key={i}
              className="w-[100%] h-[100%] grid cursor-pointer"
              onClick={() => handleClickSponsor(obj)}
            >
              <div className="flex items-start justify-start gap-[14px] ">
                <img
                  className="rounded-[6px] w-[60px] h-[60px] object-contain "
                  src={obj?.logo}
                  alt=""
                />
                <div>
                  <p className="text-regular-callout text-[#CDCDCD]">
                    {obj?.name}
                  </p>
                  <p className=" text-small text-[#606060] text-five-line">
                    {obj?.description}
                  </p>
                </div>
              </div>
              {/* <CarousleUndeline
                style={{ width: "100%", height: "auto", color: hexCode }}
              /> */}
              <div className="seperator" />
              <p
                className="text-small text-[#CDCDCD] flex items-center gap-[5px]"
                onClick={(e) => e.stopPropagation()}
              >
                Visit.{" "}
                <a href={obj?.url} target="_blank" style={linkStyle}>
                  {obj?.name}
                </a>
                <svg
                  width="15px"
                  height="15px"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8333 12.5C16.2789 12.5 12.5 16.2789 12.5 20.8333V79.1667C12.5 83.7211 16.2789 87.5 20.8333 87.5H79.1667C83.7211 87.5 87.5 83.7211 87.5 79.1667V50H79.1667V79.1667H20.8333V20.8333H50V12.5H20.8333ZM58.3333 12.5V20.8333H73.2747L34.554 59.554L40.446 65.446L79.1667 26.7253V41.6667H87.5V12.5H58.3333Z"
                    fill={hexCode}
                  />
                </svg>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrganizerInCarosel;
